export const Adapters = {
    NoMediaAdapter: () => import(
        /* webpackChunkName: "no-media-adapter" */
        './nomedia/no_media_adapter'
    ).then(exposeAdapter),
    VideoJSAdapter: () => import(
        /* webpackChunkName: "video-js-adapter" */
        './videojs/videojs_adapter'
    ).then(exposeAdapter),
    VideoJSFlashAdapter: () => import(
        /* webpackChunkName: "video-js-flash-adapter" */
        './videojs/videojs_flash_adapter'
    ).then(exposeAdapter)
};

export const exposeAdapter = module => module.Adapter;